export const getUser = state => state.user.user;
export const getUsers = state => state.user.users;
export const getUserSearchResults = state => state.user.userSearchResults;
export const getUserProfiles = state => state.user.userProfiles;
export const getLockedServiceCaseResults = state => state.user.lockedServiceCaseResults;
